import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class CryptoJsService {
  private private_key: string = `ye43@^(csd)m`;

  /**
   * generateKey
   */
  public generateKey(): string {
    const key: CryptoJS.lib.WordArray = CryptoJS.lib.WordArray.random(32);
    return CryptoJS.enc.Hex.stringify(key);
  }

  /**
   * decipherData
   */
  public async decipherData(data: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const decipher = CryptoJS.AES.decrypt(data, this.private_key).toString(CryptoJS.enc.Utf8);
      resolve(decipher);
    });
  }

  /**
   * @description Encrypt text
   * @param text text to encrypt
   * @param key key to encrypt
   * @returns text encrypted
   * @example encryptText('text', 'key') => 'text'
   */
  encryptText(text: string, key: string): string {
    return CryptoJS.AES.encrypt(text, key).toString();
  }

  /**
   * @description Encrypt object
   * @param object object to encrypt
   * @param key key to encrypt
   * @returns text encrypted
   * @example encryptObject({test:'test'}, 'key') => 'text'
   */
  encryptObject(object: any, key: string): any {
    return CryptoJS.AES.encrypt(JSON.stringify(object), key).toString();
  }

  /**
   * @param textEncrypt texto encrypted
   * @param key key to decrypt
   * @returns text decrypted
   * @example decryptText('text', 'key') => 'text'
   */
  decryptText(textEncrypt: CryptoJS.lib.CipherParams, key: string): string {
    return CryptoJS.AES.decrypt(textEncrypt.toString(), key).toString(CryptoJS.enc.Utf8);
  }

  /**
   * @param objectEncrypt object encrypted
   * @param key key to decrypt
   * @returns object decrypted
   * @example decryptObject({test:'test'}, 'key') => 'text'
   */
  decryptObject(objectEncrypt: any, key: string): any {
    const decryptedObject = CryptoJS.AES.decrypt(objectEncrypt.toString(), key);
    return JSON.parse(decryptedObject.toString(CryptoJS.enc.Utf8));
  }
}
